import { AppPrices, FrequencyPrice, InstancePrice } from '@galaxy/marketplace-apps';
import { SimplePrice, getPartnerCurrency } from '@vendasta/billing-ui';

export type ItemFrequencyPrice = SimplePrice & {
  total: number;
  minimumPrice?: number;
};

export function getFrequencyPrices(appPrices: AppPrices, editionId = '', pricingContext: string): FrequencyPrice[] {
  const appPrice = appPrices?.pricesForContexts?.[pricingContext];
  const priceForEditions = appPrice?.pricesForEditions?.[editionId];
  const currency = getPartnerCurrency(appPrice);
  return priceForEditions?.pricesForCurrencies?.[currency]?.pricesForFrequencies ?? [];
}

// instance price is automatically calculated based on: quantity, discounts, and setup fee
// to get the discounted unit price, we need to reverse engineer the instance price
export function calculateUnitPriceFromInstancePrice(instancePrice: InstancePrice, setupFee = 0, quantity = 1): number {
  const totalPricePerUnit = (instancePrice?.total ?? 0) / quantity;
  const basePricePerUnit = totalPricePerUnit - setupFee;
  return basePricePerUnit;
}
